import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { mergeAreaChartOptions } from "../../pages/Compare/chartTheme";

const GrossNetMargin: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [] } = data || {};

  const chartData: any = {
    options: mergeAreaChartOptions({
      chart: {
        id: "GrossNetMargin",
      },
      xaxis: {
        categories,
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return value.toFixed(2);
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (value: string) => {
          return `${Number(value).toFixed(2)}%`;
        },
        offsetY: -10,
      },
      markers: {
        size: 4,
      },
    }),
    chart: {
      type: "line",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">Gross &amp; Net Profit Margin</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="area"
        height={550}
      />
    </div>
  );
};

export default GrossNetMargin;
